import Vue from 'vue';
import VueRouter from 'vue-router';
import { routers } from './router';
import { isAuth } from '../api/auth';
import Util from '../libs/util';
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: routers
};

export const router = new VueRouter(RouterConfig);


router.beforeEach((to, from, next) => {
  Util.title(to.meta.title);
  if (!isAuth() && to.name !== 'login') {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

router.afterEach(to => {
  Util.openNewPage(router.app, to.name, to.params, to.query);
  window.scrollTo(0, 0);
});
